import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { confirmEmail } from '../../../services/authService';
import styles from './EmailConfirmationValidate.module.css';
import { CustomButton, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';

const EmailConfirmationValidate = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const confirmation = queryParams.get("confirmation");

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const handleConfirmEmail = useCallback(async () => {
        setIsLoading(true);
        
        if (confirmation)
            await confirmEmail(confirmation);
    
        setIsLoading(false);
    }, [confirmation]);

    useEffect(() => {
        handleConfirmEmail();
    }, [handleConfirmEmail]);

    return (
        <div className={styles.container}>

            { isLoading &&
                <CustomLoader isLoading={isLoading}/>
            }

            { !isLoading &&
                <div className={styles.card}>
                    <CustomTitle className={styles.title}>{t('email_confirmation.confirm_msg')}</CustomTitle>
                    <CustomButton onClick={() => { navigate('/login') }}>{ t('signin.go_to_login_page') }</CustomButton>
                </div>
            }
        </div>
    );
}

export default EmailConfirmationValidate;